import { atom } from "jotai";
import { Category, GamesCollection, IGame, Provider } from "../interfaces/intefaces";
import { atomWithReducer } from "jotai/utils";
import _ from "lodash";
declare const activeCategoryType: number;

const favoritesReducer = (
    prev: GamesCollection | null,
    action: { type: "add" | "remove" | "init"; payload: GamesCollection },
) => {
    if (action.type === "add") {
        return prev
            ? {
                  count: prev.count + action.payload.count,
                  games: _.concat(prev.games, action.payload.games),
              }
            : action.payload;
    }
    if (action.type === "remove") {
        return prev
            ? {
                  count: prev.count - action.payload.count,
                  games: _.differenceWith(
                      prev.games,
                      action.payload.games,
                      (a, b) => a.id === b.id,
                  ),
              }
            : prev;
    }
    if (action.type === "init") {
        return action.payload;
    }
    throw new Error("unknown action type");
};
export const gamesAtom = atom<GamesCollection | null>(null);
export const gamesHotAtom = atom<GamesCollection | null>(null);
export const gamesNewAtom = atom<GamesCollection | null>(null);
export const gamesLobbyAtom = atom<GamesCollection | null>(null);
export const gamesUserFavoritesAtom = atomWithReducer(null, favoritesReducer);
export const gameofWeekAtom = atom<IGame | null>(null);
export const currentGameAtom = atom<IGame | null>(null);
export const userIsLoggedInAtom = atom<boolean>(false);

export const categoriesAtom = atom<Category[] | null>(null);
export const categoryTypeAtom = atom<number>(activeCategoryType);
export const activeCategoryAtom = atom<number>(0);
export const currentPageAtom = atom(0);
export const providersAtom = atom<Provider[] | null>(null);
export const activeProvidersAtom = atom<number[]>([]);

export const isModalOpenAtom = atom(false);
export const gameIframeAtom = atom("");

export const gridSizeAtom = atom("xs");
export const sortOrderAtom = atom("");

export const showProvidersAtom = atom(false);

export const showBrowseModalAtom = atom(false);
